import { Component, OnInit } from '@angular/core';
import { SHARED_IMPORTS } from '../../shared/standalone-imports';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss'],
  standalone: true,
  imports: [...SHARED_IMPORTS],
})
export class RedirectComponent implements OnInit {

  constructor() { }

  public ngOnInit(): void {
    window.location.href = "https://autoverkooppartner.nl";
  }
}
